




















































import Vue from 'vue'
import FieldsTable from './components/FieldsTable'
import CreateForm from './components/CreateForm'
import EditForm from './components/EditForm'

import { FormFieldManageServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
import { ProductTypeServiceProxy, DeleteProductTypeDTO } from '@/service-proxies/app-v2/product.service-proxies'

const ffmsp = new FormFieldManageServiceProxy()
const productTypeServiceProxy = new ProductTypeServiceProxy()
const CODE = 'DNC_RESOURCE'
export default Vue.extend({
  name: 'ProductType',
  components: {
    FieldsTable,
    CreateForm,
    EditForm
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      modalLoading: false,
      modalVisible: false,
      drawerVisible: false,
      drawerLoading: false,
      currentRecord: {},
      page: {
        pageSize: 30,
        current: 1
      },
      total: 0,
      selectedRows: []
    }
  },
  created() {
    this.loadTableData()
  },
  watch: {
    page(page) {
      // console.log('page change:', page)
      this.loadTableData()
    }
  },
  methods: {
    async loadTableData() {
      try {
        this.tableLoading = true
        const res = await productTypeServiceProxy.getPageProductTypes(this.page.current, '', '', this.page.pageSize, undefined)
        // console.log(1111, res)
        this.tableData = res.records
        this.total = Number(res.total)
        this.tableLoading = false
      } catch (e) {
        this.tableLoading = false
      }
    },
    handleCreate() {
      const { form } = this.$refs.createForm.dForm
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.modalLoading = true
            await productTypeServiceProxy.createProductType({ ...values })
            this.modalLoading = false
            this.modalVisible = false
            this.$message.success(this.$t('page_resource_pool_success'))
            await this.loadTableData()
          } catch (e) {
            this.modalLoading = false
          }
        }
      })
    },
    handleEdit() {
      const { form } = this.$refs.editForm.dForm
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.drawerLoading = true
            let status = values.status ? 2 : 1
            const body = { id: this.currentRecord.id, ...values, status: status }
            await productTypeServiceProxy.updateProductType(body)
            this.drawerLoading = false
            this.drawerVisible = false
            this.$message.success(this.$t('page_resource_pool_success'))
            await this.loadTableData()
          } catch (e) {
            this.drawerLoading = false
          }
        }
      })
    },
    groupDelete() {
      this.$confirm({
        title: this.$t('page_user_management_confirm_to_delete'),
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.handleDelete(true)
            resolve()
          })
        }
      })
    },
    // type: true 批量删除； force：true 强制删除
    async handleDelete(type, force = false) {
      try {
        this.tableLoading = true
        let ids = []
        if (type) { // 批量删除
          this.selectedRows.map(row => {
            ids.push(row.id)
          })
        } else { // 单个删除
          ids.push(this.currentRecord.id)
        }
        let params = {
          productTypeIds: ids,
          force
        }
        let res = await productTypeServiceProxy.deleteProductTypes(new DeleteProductTypeDTO(params))
        this.tableLoading = false
        if (res.message && res.productTypeIds) {
          this.$confirm({
            title: res.message,
            okText: this.$t('ok'),
            cancelText: this.$t('cancel'),
            onOk: () => {
              return new Promise((resolve, reject) => {
                this.handleDelete(type, true)
                resolve()
                this.$message.success(this.$t('page_resource_pool_success'))
                this.loadTableData()
              })
            }
          })
        } else {
          this.page.current = 1
          await this.loadTableData()
          this.$message.success(this.$t('page_resource_pool_success'))
        }
      } catch (error) {
        this.tableLoading = false
      }
    },
    async handleAuth() {
      try {
        this.tableLoading = true
        let status = this.currentRecord.status === 1 ? '2' : '1'
        await productTypeServiceProxy.updateProductTypeStatus(this.currentRecord.id, status)
        await this.loadTableData()
        this.$message.success(this.$t('page_resource_pool_success'))
      } catch (error) {
        this.tableLoading = false
      }
    },
    handleAction(action) {
      this.currentRecord = action.payload
      if (action.type === 'edit') {
        if (this.drawerVisible) {
          this.$confirm({
            title: this.$t('switch_tips_title'),
            content: this.$t('switch_tips_content'),
            onOk: () => {
              this.currentRecord = action.payload
              this.drawerVisible = true
            },
            onCancel() {
              return
            }
          })
        } else {
          this.currentRecord = action.payload
          this.drawerVisible = true
        }
      } else if (action.type === 'delete') {
        this.handleDelete()
      } else { // 启用/禁用
        this.handleAuth()
      }
    },
    handleSelectRows(data) {
      this.selectedRows = data
    }
  }
})
